import React from 'react';
import { Modal } from 'gatorcomponents';
import ServerTypeSelector from '../ServerTypeSelector';
import * as Styles from './ServerTypeModal.styles';
import useLocale from '@/hooks/useLocale';

const ServerTypeModal = ({
  onClose,
  onSelectVPS,
  onSelectDedicated,
}) => {
  const { productDetails: productDetailsLocale } = useLocale();
  const { advancedHosting: advancedHostingLocale } = productDetailsLocale || {};
  const { serverTypeModal: serverTypeModalLocale } = advancedHostingLocale || {};

  return (
    <Modal
      onClose={onClose}
      maxWidth={800}
      noContentPadding
      title={serverTypeModalLocale?.title}
      testId="server-type-modal"
    >
      <Styles.ModalContent>
        <Styles.ModalHeader>
          <Styles.ModalSubtitle data-testid="server-type-modal-subtitle">{serverTypeModalLocale?.subtitle}</Styles.ModalSubtitle>
        </Styles.ModalHeader>

        <ServerTypeSelector
          locale={serverTypeModalLocale?.selector}
          onSelectVPS={onSelectVPS}
          onSelectDedicated={onSelectDedicated}
        />
      </Styles.ModalContent>
    </Modal>
  );
};

export default ServerTypeModal;
